import * as React from 'react';

import Icon from './Icon';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const CartIcon: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Path
        fill={props.fill}
        d="M5.833 18.333c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177c0-.458.164-.85.49-1.177.327-.326.719-.49 1.177-.49.459 0 .851.164 1.177.49.327.327.49.719.49 1.177 0 .459-.163.851-.49 1.177-.326.327-.718.49-1.177.49Zm8.334 0c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177c0-.458.163-.85.49-1.177.326-.326.718-.49 1.177-.49.458 0 .85.164 1.177.49.326.327.49.719.49 1.177 0 .459-.164.851-.49 1.177-.327.327-.719.49-1.177.49ZM5.125 5l2 4.166h5.833L15.25 5H5.125Zm-.792-1.667h12.292c.32 0 .563.142.73.427a.84.84 0 0 1 .02.865l-2.958 5.333a1.67 1.67 0 0 1-.615.646c-.257.153-.538.229-.844.229H6.75L5.833 12.5h10v1.666h-10c-.625 0-1.097-.274-1.416-.823-.32-.548-.334-1.093-.042-1.635L5.5 9.666l-3-6.333H.833V1.666h2.709l.791 1.667Z"
      />
    </Icon>
  );
};

export default CartIcon;
